(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-content"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__mediaWithContentParallaxSimple) return;
  window.__mediaWithContentParallaxSimple = true;

  const prefersReduced = matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  const MOBILE_Q = '(max-width: 749px)';
  const isMobile = () => matchMedia?.(MOBILE_Q).matches;

  const sections = () =>
    Array.from(document.querySelectorAll('.media-with-content[data-parallax-enabled="true"]'));

  const pickMedia = (root) =>
    root.querySelector('img, picture > img, video') || root.firstElementChild || root;

  function makeItems() {
    const mobile = isMobile();
    return sections().map(sec => {
      const allowMobile = sec.getAttribute('data-parallax-mobile') === 'true';
      if (mobile && !allowMobile) return null;

      const strength = parseFloat(sec.getAttribute('data-parallax-strength')) || 40;
      const mediaBlock = sec.querySelector(':scope > .media-block') || sec.querySelector('.media-block');
      if (!mediaBlock) return null;

      const target = pickMedia(mediaBlock);
      if (!target) return null;
      target.classList.add('parallax-target');

      const h = mediaBlock.getBoundingClientRect().height || 1;
      const scale = 1 + (2 * strength) / h;

      target.dataset.parallaxScale = String(scale);

      return { mediaBlock, target, strength };
    }).filter(Boolean);
  }

  let items = [];
  let ticking = false;

  function applyParallax() {
    const vh = window.innerHeight || 1;

    items.forEach(({ mediaBlock, target, strength }) => {
      const rect = mediaBlock.getBoundingClientRect();
      const center = rect.top + rect.height / 2;
      const delta = (vh / 2 - center);
      const translate = (delta / vh) * strength * 2;

      const scale = parseFloat(target.dataset.parallaxScale || '1');
      const tComp = translate / (scale || 1);

      target.style.transform = `translate3d(0, ${tComp.toFixed(2)}px, 0) scale(${scale.toFixed(4)})`;
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      applyParallax();
      ticking = false;
    });
  }

  function recalc() {
    items.forEach(({ mediaBlock, target, strength }) => {
      const h = mediaBlock.getBoundingClientRect().height || 1;
      const scale = 1 + (2 * strength) / h;
      target.dataset.parallaxScale = String(scale);
    });
    applyParallax();
  }

  function init() {
    if (prefersReduced) return;
    items = makeItems();
    if (!items.length) return;

    applyParallax();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', recalc, { passive: true });

    document.addEventListener('shopify:section:load', () => { items = makeItems(); applyParallax(); });
    document.addEventListener('shopify:section:unload', () => { items = makeItems(); applyParallax(); });
    document.addEventListener('shopify:block:select', applyParallax);
    document.addEventListener('shopify:block:deselect', applyParallax);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
